import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M4 9.777c0-.3.243-.543.544-.543a.544.544 0 0 0 .542-.58l-.208-3.12a1.5 1.5 0 0 1 1.77-1.574l7.12 1.319a1.5 1.5 0 0 1 1.22 1.325l.226 2.275c.02.201.19.355.392.355.218 0 .394.176.394.393v4.857a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.178 4.4H6.5a1.1 1.1 0 0 0-1.1 1.1v3.9H4V5.5A2.5 2.5 0 0 1 6.5 3h.678c.534 0 1.055.168 1.489.48a2.54 2.54 0 0 0 1.488.481H13.5a2.5 2.5 0 0 1 2.5 2.5V9.4h-1.4V6.461a1.1 1.1 0 0 0-1.1-1.1h-3.345a3.94 3.94 0 0 1-2.307-.745 1.15 1.15 0 0 0-.67-.216"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.178 6.614H6.5a1.1 1.1 0 0 0-1.1 1.1V9.5H4V7.714a2.5 2.5 0 0 1 2.5-2.5h.678c.534 0 1.055.168 1.489.48.433.313.954.48 1.488.48H13.5a2.5 2.5 0 0 1 2.5 2.5V9.5h-1.4v-.825a1.1 1.1 0 0 0-1.1-1.1h-3.345a3.94 3.94 0 0 1-2.307-.745 1.15 1.15 0 0 0-.67-.216"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.5 9.71h-9a1.1 1.1 0 0 0-1.1 1.1v3.69a1.1 1.1 0 0 0 1.1 1.1h9a1.1 1.1 0 0 0 1.1-1.1v-3.69a1.1 1.1 0 0 0-1.1-1.1m-9-1.4a2.5 2.5 0 0 0-2.5 2.5v3.69A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-3.69a2.5 2.5 0 0 0-2.5-2.5z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 11.667c0-.368.298-.667.667-.667h2.666a.667.667 0 0 1 0 1.333H8.667A.667.667 0 0 1 8 11.667"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=PortfolioIcon20.js.map